export default "__VITE_ASSET__BS4dNUaE__"